module.exports = __webpack_public_path__ + "media/images/heimdall_icon-0d7a64953b400818bd87d4b0b5e97584.png";